import React from 'react';
import Icon from '../../../components/AppIcon';

const FeatureUsageMatrix = ({ data }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2 bg-orange-50 rounded-lg">
          <Icon name="Grid" className="w-5 h-5 text-orange-600" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-gray-900">Feature Usage</h2>
          <p className="text-sm text-gray-500">Adoption rates by feature</p>
        </div>
      </div>

      <div className="space-y-3">
        {data?.map((feature, index) => (
          <div key={index} className="p-4 border border-gray-200 rounded-lg hover:border-gray-300 transition-colors">
            <div className="flex items-center justify-between mb-2">
              <span className="font-medium text-gray-900">{feature?.feature}</span>
              <span className="text-sm font-semibold text-blue-600">{feature?.adoptionRate}%</span>
            </div>
            <div className="flex items-center justify-between text-sm text-gray-600 mb-2">
              <span>{feature?.users?.toLocaleString()} users</span>
            </div>
            <div className="relative h-2 bg-gray-100 rounded-full overflow-hidden">
              <div 
                className="absolute top-0 left-0 h-full bg-gradient-to-r from-blue-500 to-blue-600 rounded-full transition-all duration-500"
                style={{ width: `${feature?.adoptionRate}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureUsageMatrix;